import { useInfiniteQuery } from '../use-query';
import { extendContainerValidator, toIsoDate } from '../../utils';
import { gateOutsService } from '../../services';
import { TABLE } from '../../const';

export const useGateOutsQuery = (keys: any = {}) => {
  if (keys.containerNumber?.length < 3 || !extendContainerValidator(keys.containerNumber))
    delete keys.containerNumber;
  if (keys.startDate) keys.startDate = toIsoDate(keys.startDate, true);
  if (keys.endDate) keys.endDate = toIsoDate(keys.endDate, true);

  const result = useInfiniteQuery(
    ['gate-outs', JSON.stringify(keys)],
    ({ pageParam = 0 }) =>
      gateOutsService
        .getAll({
          params: {
            ...keys,
            take: TABLE.PAGE_MAX_SIZE,
            skip: pageParam * TABLE.PAGE_MAX_SIZE,
            notLoading: true,
            pageParam,
          },
        })
        .then((res) => res.data),
    {
      getNextPageParam: (data: any) => {
        const loaded = (data.pageParam + 1) * TABLE.PAGE_MAX_SIZE;
        return loaded < data.totalCount ? data.pageParam + 1 : undefined;
      },
      select: (data: any) => ({
        ...data,
        data: data.pages.flatMap((page: any) => page.data),
        totalCount: data.pages[0]?.totalCount ?? 0,
      }),
      keepPreviousData: false,
    },
  );

  return { ...result, data: result?.data || { data: [], totalCount: 0 } };
};
